import { render, staticRenderFns } from "./ExhibitionInformationDetails.vue?vue&type=template&id=058269b2&"
import script from "./ExhibitionInformationDetails.vue?vue&type=script&lang=js&"
export * from "./ExhibitionInformationDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionInformationDetails.vue?vue&type=style&index=0&id=058269b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports